import {Component, computed, inject} from '@angular/core';
import {Router} from '@angular/router';
import {Button} from 'primeng/button';
import {TranslocoPipe} from '@jsverse/transloco';
import {HrTool} from '@frontend/directus';
import {HrToolService} from '../hr-tool.service';
import {ExtendedHrTool} from '../hr-tool.types';
import {APP_ROUTES} from '../../../app.routes';

/** Fixed bottom bar (base44 CompareBar) that surfaces the selected comparison tools and links to the
 * full side-by-side comparison view. Comparison needs at least two tools. */
@Component({
  selector: 'app-hr-tool-compare-bar',
  imports: [Button, TranslocoPipe],
  templateUrl: './hr-tool-compare-bar.component.html',
})
export class HrToolCompareBarComponent {
  private readonly hrToolsService = inject(HrToolService);
  private readonly router = inject(Router);

  protected readonly maxTools = 3;
  protected readonly tools = this.hrToolsService.comparisonHrTools;
  protected readonly canCompare = computed(() => this.tools().length >= 2);
  protected readonly emptySlots = computed(() =>
    Array.from({length: Math.max(0, this.maxTools - this.tools().length)}),
  );

  protected toolName(tool: HrTool): string {
    return (tool as ExtendedHrTool).translatedName || tool.name;
  }

  protected hideBrokenImage(event: Event): void {
    (event.target as HTMLImageElement).style.display = 'none';
  }

  protected remove(id: string): void {
    this.hrToolsService.removeToolFromComparison(id);
  }

  protected clearAll(): void {
    this.hrToolsService.clearAllComparisonTools();
  }

  protected openCompare(): void {
    if (this.canCompare()) {
      void this.router.navigate([APP_ROUTES.HR_TOOLS_COMPARE]);
    }
  }
}
